import {
  Button, AlertDialog, AlertDialogBody, AlertDialogFooter, AlertDialogHeader,
  AlertDialogContent, AlertDialogOverlay,
} from "@chakra-ui/react";

export default function DeleteModal({
  OnSubmit = () => {},
  IsLoading = false,
  OnClose = () => {},
  IsOpen = false,
  FolderId,
  texts = {} 
}) {
  const fileManagerTexts = texts?.fileManager || {};
  const generalTexts = texts?.general || {};

  const handleDelete = async () => {
    const success = await OnSubmit({
      FolderId: FolderId,
      Tab: "Delete",
    });

    if (success) {
      OnClose();
    }
  };

  return (
    <AlertDialog
      isOpen={IsOpen}
      onClose={OnClose}
      isCentered
    >
      <AlertDialogOverlay>
        <AlertDialogContent sx={{ bg: 'var(--modal-bg)', color: 'var(--modal-text)' }}>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            {fileManagerTexts.deleteFolder || "Delete Folder"}
          </AlertDialogHeader>

          <AlertDialogBody>
            {fileManagerTexts.deleteFolderConfirm || "Are you sure you want to delete this folder? This action cannot be undone."}
          </AlertDialogBody>

          <AlertDialogFooter>
            <Button 
              variant="ghost" 
              onClick={OnClose}
              sx={{ _hover: { bg: 'var(--modal-btn-ghost-hover-bg)' } }}
            >
              {generalTexts.cancel || "Cancel"}
            </Button>
            <Button 
              onClick={handleDelete} 
              ml={3} 
              isLoading={IsLoading}
              sx={{
                bg: 'var(--btn-danger-bg)',
                color: 'var(--btn-danger-text)',
                _hover: { bg: 'var(--btn-danger-hover-bg)' }
              }}
            >
              {fileManagerTexts.delete || "Delete"}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
}